"use client"

import { Compass } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CompassIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CompassIcon = component(Icon)({ as: Compass })
